import React, { useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { auth } from '../lib/api';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiLock, FiTool } = FiIcons;

const ResetPassword = () => {
  const [params] = useSearchParams();
  const token = params.get('token');
  const linkError = params.get('error');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError("Passwords don't match");
    setError(null);
    setSubmitting(true);
    try {
      await auth('reset-password', { newPassword: password, token });
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setSubmitting(false);
    }
  };

  const invalid = !token || linkError;

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50 dark:bg-slate-950">
      <div className="w-full max-w-md space-y-8 text-center">
        <div className="inline-flex bg-blue-600 p-4 rounded-2xl shadow-xl shadow-blue-900/20">
          <SafeIcon icon={FiTool} className="w-8 h-8 text-white" />
        </div>
        <h1 className="text-3xl font-black text-slate-900 dark:text-white tracking-tight">Choose a new password</h1>

        <div className="bg-white dark:bg-slate-900 p-8 rounded-3xl border border-slate-200 dark:border-slate-800 shadow-2xl space-y-5 text-left">
          {done ? (
            <p className="text-sm text-slate-600 dark:text-slate-300">
              Your password has been updated. <Link to="/login" className="text-blue-600 font-black hover:underline">Sign in</Link>
            </p>
          ) : invalid ? (
            <p className="text-sm text-slate-600 dark:text-slate-300">
              This reset link is invalid or has expired. <Link to="/login" className="text-blue-600 font-black hover:underline">Request a new one</Link>
            </p>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              {error && (
                <div className="p-4 bg-red-50 dark:bg-red-500/10 border border-red-200 dark:border-red-500/20 rounded-xl text-xs font-bold text-red-600 dark:text-red-400">
                  {error}
                </div>
              )}
              {[['New password', password, setPassword], ['Confirm password', confirm, setConfirm]].map(([label, value, setter]) => (
                <div key={label} className="space-y-1.5">
                  <label className="text-[10px] font-black text-slate-500 uppercase tracking-widest ml-1">{label}</label>
                  <div className="relative">
                    <SafeIcon icon={FiLock} className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400" />
                    <input
                      type="password"
                      required
                      minLength={8}
                      autoComplete="new-password"
                      value={value}
                      onChange={(e) => setter(e.target.value)}
                      className="w-full bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl pl-12 pr-4 py-3.5 text-sm outline-none focus:border-blue-500 text-slate-900 dark:text-white"
                    />
                  </div>
                </div>
              ))}
              <button
                type="submit"
                disabled={submitting}
                className="w-full bg-blue-600 hover:bg-blue-500 disabled:opacity-60 text-white font-black py-4 rounded-xl shadow-lg shadow-blue-900/20 transition-all"
              >
                {submitting ? 'UPDATING...' : 'UPDATE PASSWORD'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
